import * as React from 'react';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import { IComponent } from '@/types/_app';
import Podcast from '@/types/pages/api/podcasts/Podcast';
import PodcastPageLayout from '@/components/pages/podcasts/layout/PodcastPageLayout';

export interface PodcastPageControllerProps {
    podcasts: Podcast[];
}

export const PodcastsPageController: IComponent<any> = ({ podcasts }: PodcastPageControllerProps) => {
    return <PodcastPageLayout podcasts={podcasts} />;
};

export default withExceptionCatcher(PodcastsPageController);
